export default [
  {
    path: 'company-division',
    meta: {
      title: 'Company > Division',
      auth: ['Admin', 'Super Admin'],
      hidden: true
    },
    component: () => import('./pages/index'),
    redirect: 'company-division/list',
    children: [
      {
        path: 'list',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'List',
          resource: 'companyDivision',
          icon: 'playlist_add_check',
          hidden: false
        },
        component: () => import('./pages/list')
      },
      {
        path: 'edit/:id',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Edit',
          resource: 'companyDivision',
          icon: 'mode_edit',
          hidden: true
        },
        component: () => import('./pages/edit')
      },
      {
        path: 'add',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Add',
          resource: 'companyDivision',
          icon: 'add_circle_outline',
          hidden: false
        },
        component: () => import('./pages/add')
      }
    ]
  }
]
